export default {"src":"/_next/static/media/NDAQ.65b34d02.svg","height":18,"width":18};